import { jsxs, jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import cns from '../../node_modules/classnames/index.js';
import { getRect, getViewportSize } from '../Utils/documentUtils.js';

/**
 Il componente InfiniteScroll
 rappresenta un'area per il caricamento progressivo dei dati presenti quqando l'utente scrolla.
 */
class InfiniteScroll extends Component {
    constructor(props) {
        super(props);
        this.scrollArea = null;
        this.onScroll = () => {
            const { windowHeight, isLoading } = this.state;
            const offSet = windowHeight - getRect(this.refInfiniteScrollAnchor).bottom;
            if (offSet >= 0 && !isLoading) {
                this.loadMore();
            }
        };
        this.loadMore = () => {
            const { children, stopLoading, onLoadMore } = this.props;
            if (stopLoading)
                return;
            this.setState({ isLoading: true }, () => {
                if (onLoadMore) {
                    onLoadMore().then(() => this.setState({
                        isLoading: false,
                    }));
                }
                else if (children) {
                    const child = children;
                    if (child.type.prototype.loadMore) {
                        child.type.prototype.loadMore().then(() => this.setState({
                            isLoading: false,
                        }));
                    }
                }
            });
        };
        this.state = {
            windowHeight: 0,
            isLoading: false,
        };
    }
    componentDidMount() {
        const { container } = this.props;
        this.scrollArea = (container && document.getElementsByClassName(container)[0]) || document.getElementsByClassName('sidebar__body')[0];
        if (this.scrollArea) {
            this.setState({
                windowHeight: getViewportSize().height,
            }, () => {
                this.scrollArea.addEventListener('scroll', this.onScroll);
            });
        }
    }
    componentWillUnmount() {
        this.scrollArea.removeEventListener('scroll', this.onScroll);
    }
    render() {
        const { children, className, } = this.props;
        const classes = cns('infiniteScroll', className);
        return (jsxs("div", { className: classes, children: [children, jsx("span", { ref: (r) => { this.refInfiniteScrollAnchor = r; } })] }));
    }
}
InfiniteScroll.defaultProps = {
    children: null,
    className: '',
    container: '',
    onLoadMore: null,
    stopLoading: false,
};

export { InfiniteScroll as default };
